module.exports = __webpack_public_path__ + "img/bcc394.ea7b2150.jpeg";